export const EMITTER_TYPE_EMITTER = 'Emitter';
export const EMITTER_TYPE_FOLLOW = 'FollowEmitter';
